import { render, staticRenderFns } from "./IndexCompanies.vue?vue&type=template&id=0c5dd0f8&"
import script from "./IndexCompanies.vue?vue&type=script&lang=js&"
export * from "./IndexCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports